import React, { useState, useEffect } from "react";
import CommunityLayout from "../components/layouts/CommunityLayout";
import { usePageTitle } from '../hooks/usePageTitle';
import { useParams } from "react-router-dom";
import { BlueEnvelopeProgramOptions } from "../utils";
import BlueEnvelopeForm from "../components/blueenvelope/BlueEnvelopeForm";
import BlueEnvelopeTemplate from "../components/blueenvelope/BlueEnvelopeTemplate";
import BlueEnvelopeOtherDocuments from "../components/blueenvelope/BlueEnvelopeOtherDocuments";
import WefayoBlueCard from "../components/blueenvelope/WefayoBlueCard";

const BlueEnvelopeProgram = () => {
    usePageTitle('Blue Envelope Program - Wefayo');

    const { module } = useParams();
    const boardOption = BlueEnvelopeProgramOptions.find(option => option.module === module);
    const [isLoading, setIsLoading] = useState(true);

    // Reset loading state when module changes
    useEffect(() => {
        setIsLoading(true);
    }, [module]);

    const handleIframeLoad = () => {
        setIsLoading(false);
    };

    return (
        <CommunityLayout currentPage={"blue-envelope-program"} onCommunitiesLoaded={() => { }} isFullPageWidth={true} overflow={'overflow-y-auto'}  >
            <div className={`relative w-full lg:w-[calc(100vw-250px)] h-[calc(100vh-70px)] md:mx-auto ${boardOption?.name === 'Envelope' ? 'blue-envelope-print-page' : ''}`} style={{ marginTop: "4rem" }}>
                {/* Loading Spinner */}
                {/* {isLoading && (
                    <div className="absolute inset-0 flex flex-col items-center justify-center bg-white rounded-md z-10">
                        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-blue-600 mb-4"></div>
                        <p className="text-gray-600 text-lg font-medium">Loading {boardOption?.name || 'Blue Envelope Program'}...</p>
                        <p className="text-gray-400 text-sm mt-2">Please wait</p>
                    </div>
                )} */}


                {/*  */}

                {boardOption.module === 'form' && (
                    <BlueEnvelopeForm virtual={false} />
                )}

                {boardOption.module === 'envelope' && (
                    <BlueEnvelopeTemplate />
                )}


                {boardOption.module === 'overview' && (
                    <BlueEnvelopeOtherDocuments />
                )}

                {boardOption.module === 'card' && (
                    <WefayoBlueCard />
                )}

            </div>
        </CommunityLayout>
    );
};

export default BlueEnvelopeProgram;

